import DefaultNumberComparer from './DefaultNumberComparer';
import DefaultObjectComparer from './DefaultObjectComparer';
import DefaultStringComparer from './DefaultStringComparer';
/**
 * Default implementation
 */
export class DefaultComparer {
    compare(x, y) {
        if (typeof x == 'string' && typeof y == 'string') {
            return DefaultComparers.StringComparer.compare(x, y);
        }
        else if (typeof x == 'number' && typeof y == 'number') {
            return DefaultComparers.NumberComparer.compare(x, y);
        }
        else {
            return DefaultComparers.ObjectComparer.compare(x, y);
        }
    }
    equals(x, y) {
        if (typeof x == 'string' && typeof y == 'string') {
            return DefaultComparers.StringComparer.equals(x, y);
        }
        else if (typeof x == 'number' && typeof y == 'number') {
            return DefaultComparers.NumberComparer.equals(x, y);
        }
        else {
            return DefaultComparers.ObjectComparer.equals(x, y);
        }
    }
    greaterThan(x, y) {
        return this.compare(x, y) > 0;
    }
    greaterThanOrEqual(x, y) {
        return this.compare(x, y) >= 0;
    }
    lessThan(x, y) {
        return this.compare(x, y) < 0;
    }
    lessThanOrEqual(x, y) {
        return this.compare(x, y) <= 0;
    }
}
const DefaultComparers = {
    DefaultComparer: new DefaultComparer(),
    StringComparer: new DefaultStringComparer(),
    NumberComparer: new DefaultNumberComparer(),
    ObjectComparer: new DefaultObjectComparer(),
};
export default DefaultComparers;
